package sample

data object FeaturedFileList : Map<String, List<String>> by mapOf(
    // /home/runner/work/compose-preview-lab/compose-preview-lab/docs/.composepreviewlab/featured/sample design system
    "sample design system" to listOf(
        "uiLib/src/**/*.kt"
    ),
) {
    val `sample_design_system` get() = this["sample design system"]!!
}